<main class="relative flex flex-col gap-6">
    <ng-container *ngTemplateOutlet="select" />

    <div
        class="flex flex-col gap-6"
        [class.invisible]="status() !== 'complete'"
    >
        <ng-container *ngTemplateOutlet="countSection" />
        <div class="border-b border-gray-100">
            <div class="w-[20rem]">
                <app-segment
                    noBorder
                    [(value)]="segment"
                    (valueChange)="segmentChange()"
                    [options]="segments()"
                />
            </div>
        </div>
        <div>
            <router-outlet />
        </div>
    </div>

    @if (status() === "loading") {
        <div
            class="absolute inset-0 flex flex-col gap-3 justify-center items-center h-[30rem]"
        >
            <app-icon
                name="line-md:loading-alt-loop"
                class="text-zinc-800 !size-20"
            />
            <div class="flex flex-col items-center text-gray-500">
                <p>수납 내역과 업로드된 결제 내역을 분석하고 있습니다.</p>
                <p>분석에는 약 1분 ~ 5분 정도가 소요될 수 있습니다.</p>
                <p>잠시만 기다려주세요.</p>
            </div>
        </div>
    }
</main>

<ng-template #select>
    <section id="select" class="flex gap-6 items-center">
        <ng-container *ngTemplateOutlet="monthPicker" />
        <app-custom-select
            required
            multiple
            label="선생님"
            [items]="teachers()"
            [(value)]="teacherIds"
            bindLabel="username"
            bindValue="id"
            class="min-w-[15rem]"
        />
        <div class="flex items-end gap-6 w-full">
            <app-abnormal-payment-file-uploader
                class="w-full"
                label="첨부파일"
                required
                [(value)]="uploadFile"
                (valueChange)="handleUpload($event!)"
            />
            @if (uploadFile()) {
                <button
                    (click)="reset()"
                    class="rounded-xl border h-14 w-20 hover:bg-gray-50 transition-colors flex items-center justify-center"
                >
                    <app-icon
                        name="solar:refresh-bold-duotone"
                        class="text-gray-500"
                    />
                </button>
            }
        </div>
    </section>
</ng-template>

<ng-template #monthPicker>
    <div class="flex flex-col gap-2">
        <app-label [required]="true">월</app-label>
        <div class="flex gap-3 items-center">
            <app-month-picker
                [(value)]="startMonth"
                (valueChange)="monthChange()"
                (reset)="startMonth.set(undefined)"
            />
            <p>-</p>
            <app-month-picker
                [(value)]="endMonth"
                (valueChange)="monthChange()"
                (reset)="endMonth.set(undefined)"
            />
        </div>
    </div>
</ng-template>

<ng-template #countSection>
    @if (count(); as count) {
        <section id="result-count">
            <div
                class="rounded-xl border border-gray-100 p-6 flex gap-6 items-center"
            >
                <div class="flex-1 flex flex-col gap-1">
                    <p class="text-gray-400">Excel 업로드</p>
                    <div class="flex gap-1 items-center">
                        <app-icon
                            name="mdi:file-upload-outline"
                            class="!size-5 text-primary"
                        />
                        <p class="text-primary font-semibold text-xl">
                            {{ count.total | number }}
                        </p>
                    </div>
                </div>
                <div class="h-10 w-px bg-gray-100"></div>
                <div class="flex-1 flex flex-col gap-1">
                    <p class="text-gray-400">정상</p>
                    <div class="flex gap-1 items-center">
                        <app-icon
                            name="material-symbols:check-circle-outline-rounded"
                            class="!size-5 text-success"
                        />
                        <p class="text-success font-semibold text-xl">
                            {{ count.complete | number }}
                        </p>
                    </div>
                </div>
                <div class="h-10 w-px bg-gray-100"></div>
                <div class="flex-1 flex flex-col gap-1">
                    <p class="text-gray-400">이상 결제</p>
                    <div class="flex gap-1 items-center">
                        <app-icon
                            name="ic:round-warning-amber"
                            class="!size-5 text-warning"
                        />
                        <p class="text-warning font-semibold text-xl">
                            {{ count.abnormal | number }}
                        </p>
                    </div>
                </div>
                <div class="h-10 w-px bg-gray-100"></div>
                <div class="flex-1 flex flex-col gap-1">
                    <p class="text-gray-400">실패</p>
                    <div class="flex gap-1 items-center">
                        <app-icon
                            name="ic:round-cancel-presentation"
                            class="!size-5 text-danger"
                        />
                        <p class="text-danger font-semibold text-xl">
                            {{ count.failed | number }}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    }
</ng-template>
